import { render, staticRenderFns } from "./ReferAFriend.vue?vue&type=template&id=2a373f02&"
import script from "./ReferAFriend.vue?vue&type=script&lang=js&"
export * from "./ReferAFriend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports